<template>
    <app-layout title="Dokumen Pemilihan">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <!-- Tombol Kembali di bagian atas -->
                            <div class="flex justify-start mb-4">
                                <button @click="goBack" 
                                       class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 flex items-center">
                                    <i class="pi pi-arrow-left mr-2"></i> Kembali
                                </button>
                            </div>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion :multiple="true" :activeIndex="[0, 1, 2, 3, 4]">
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Paket Pengadaan</span>
                                            </span>
                                        </template>
                                        <FormAttributePenyusunan 
                                            :form="form.attribut_penyusunan" 
                                            :required="true"
                                            @paket-detail-updated="handlePaketDetailUpdate"
                                        />
                                        <!-- <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" value="Jenis Pengadaan" />
                                                <div class="w-3/4">
                                                    <Checkbox v-model="form.attribut_penyusunan.is_tender" :binary="true" inputId="is_tender" />
                                                    <label for="is_tender" class="ml-2 text-sm text-gray-600">Tender</label>
                                                </div>
                                            </div>
                                        </div> -->
                                    </AccordionTab>
                                    <AccordionTab v-if="form.file_uploads.length > 0">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">File</span>
                                            </span>
                                        </template>
                                        <FileInput :file_uploads="form.file_uploads" :exlude_hps="true" :required="true"  />
                                    </AccordionTab>
                                    <AccordionTab v-if="
                                        dataViewDokumenPengadaan.has_isian_penyedia
                                    ">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Penyedia</span>
                                            </span>
                                        </template>
                                        <SelectPenyedia :list_penyedia="list_penyedia"
                                            :jenis_pekerjaan_id="dataViewDokumenPengadaan.paket_pengadaan?.jenis_pengadaan || null" />
                                    </AccordionTab>
                                    <AccordionTab v-if="
                                        dataViewDokumenPengadaan.has_isian_hps
                                    ">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">HPS</span>
                                                <span v-if="!isHpsValid" class="text-red-500 text-sm ml-2">
                                                    (Data HPS tidak valid)
                                                </span>
                                            </span>
                                        </template>
                                        <FileHpsInput
                                            :file_hps="form.hps.file_hps"
                                            @update:file_hps="handleFileHpsUpdate"
                                            @update:detail_hps="handleDetailHpsUpdate"
                                            @validation-changed="updateHpsValidation"
                                            :pagu_anggaran="paketDetail ? paketDetail.pagu_anggaran : 0"
                                            :disabled="!paketDetail"
                                            >
                                        </FileHpsInput>
                                        <div v-if="hpsError" class="text-red-500 text-sm mt-2">{{ hpsError }}</div>
                                    </AccordionTab>
                                </Accordion>
                            </div>
                            <div class="flex justify-between mt-5">
                                <button @click="goBack" 
                                       class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 flex items-center">
                                    <i class="pi pi-arrow-left mr-2"></i> Kembali
                                </button>
                                <button @click="submitForm" 
                                       :disabled="!isFormValid || isSubmitting" 
                                       :class="{
                                           'px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600': isFormValid && !isSubmitting,
                                           'px-4 py-2 bg-gray-400 text-white rounded cursor-not-allowed': !isFormValid || isSubmitting
                                       }">
                                    <span v-if="isSubmitting" class="flex items-center">
                                        <i class="pi pi-spin pi-spinner mr-2"></i> Mengirim...
                                    </span>
                                    <span v-else>Submit</span>
                                </button>
                            </div>
                        </div>
                    </section>
                </div>  
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import BreadCrumb from "@/Components/BreadCrumb";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import JetLabel from "@/Jetstream/Label";
import FileInput from "./../partials/FileInput.vue";
import JadwalInput from "./../partials/JadwalInput.vue";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import SelectPenyedia from "../partials/SelectPenyedia.vue";
import FileHpsInput from "../partials/FileHpsInput.vue";
import FormAttributePenyusunan from "../partials/FormAttributePenyusunan.vue";
import axios from "axios";
import { Inertia } from "@inertiajs/inertia";
import { required } from "@vuelidate/validators";
import Checkbox from 'primevue/checkbox';

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        Accordion,
        AccordionTab,
        JetLabel,
        FileInput,
        JadwalInput,
        InputNumber,
        Dropdown,
        RadioButton,
        SelectPenyedia,
        FileHpsInput,
        FormAttributePenyusunan,
        Checkbox,
    },
    props: {
        action: String,
        dataViewDokumenPengadaan: Object,
        files: [Object, Array],
    },
    mounted() {
        console.log(
            "DATA dataViewDokumenPengadaan: ",
            this.dataViewDokumenPengadaan
        );
        this.initializeFile();
    },
    data() {
        return {
            isHpsValid: false,
            isFormValid: false,
            isSubmitting: false,
            hpsError: '',
            paketDetail: null,
            form: {
                attribut_penyusunan: {
                    paket_pengadaan: null,
                    is_tender: false,
                    metode_evaluasi: "1f"
                },
                hps: {
                    file_hps: null,
                    detail_hps: []
                },
                file_uploads: [],
            },
        };
    },
    methods: {
        handlePaketDetailUpdate(detail) {
            this.paketDetail = detail;
            // Jika paket di-deselect, reset HPS dan file-nya
            if (!detail) {
                this.form.hps.file_hps = null;
                this.form.hps.detail_hps = [];
                this.isHpsValid = false;
                // Anda mungkin perlu menambahkan logika untuk mereset komponen FileHpsInput secara eksplisit jika diperlukan
            }
            this.checkFormValidity();
        },
        handleFileHpsUpdate(file) {
            this.form.hps.file_hps = file;
            this.checkFormValidity();
        },
        handleDetailHpsUpdate(detailHps) {
            this.form.hps.detail_hps = detailHps;
            this.checkFormValidity();
        },
        updateHpsValidation(isValid) {
            this.isHpsValid = isValid;
            this.checkFormValidity();
        },

        checkFormValidity() {
            // Check all required form validations here
            if (this.dataViewDokumenPengadaan.has_isian_hps) {
                if (!this.form.hps.file_hps || !Array.isArray(this.form.hps.detail_hps) || this.form.hps.detail_hps.length === 0) {
                    this.isFormValid = false;
                    this.hpsError = '';
                    return;
                }
            }
            if (this.dataViewDokumenPengadaan.has_isian_hps && !this.isHpsValid) {
                this.isFormValid = false;
                this.hpsError = '';
                return;
            }
            // Validasi total HPS tidak boleh melebihi pagu
            const pagu = this.paketDetail?.pagu_anggaran || this.dataViewDokumenPengadaan?.paket_pengadaan?.pagu_anggaran || 0;
            const totalHps = (this.form.hps.detail_hps || []).reduce((sum, item) => sum + ((item.volume || 0) * (item.harga_satuan || 0)), 0);
            if (pagu > 0 && totalHps > pagu) {
                this.isFormValid = false;
                this.hpsError = `Total HPS (Rp ${this.formatCurrency(totalHps)}) tidak boleh melebihi Pagu Anggaran (Rp ${this.formatCurrency(pagu)})`;
                return;
            }
            this.hpsError = '';
            // If all validations pass, enable the form
            this.isFormValid = true;
        },
        
        calculateMin(each_bobot) {
            return 0;
        },
        calculateMax(each_bobot) {
            const siblingSum = this.form.listBobotPenilaian
                .filter((bobot) => bobot !== each_bobot)
                .reduce((sum, bobot) => sum + (bobot.percentage || 0), 0);
            return 100 - siblingSum;
        },
        initializeFile() {
            this.dataViewDokumenPengadaan.file.forEach((file) => {
                this.form.file_uploads.push({
                    id_file_dokumen_pengadaan: file.id,
                    id_jadwal_pengadaan: file.id_jadwal_pengadaan,
                    id_dokumen_pengadaan: file.id_dokumen_pengadaan,
                    id_file_dokumen_prosedur: file.id_file_dokumen_prosedur,
                    kode_file: file.kode_file,
                    kode_prosedur: file.kode_prosedur,
                    nama_file: file.nama_file,
                    file_path: file.file_path,
                    file_type: file.file_type,
                    file_dokumen_type: file.file_dokumen_type,
                    file_dokumen_type_id: file.file_dokumen_type_id,
                    multiple: file.is_multiple === 1,
                    is_required: file.is_required, // Include is_required field
                    new_file: [],
                });
            });
        },
        validateFiles() {
            if (!this.form.attribut_penyusunan.paket_pengadaan) {
                alert('Paket Pengadaan wajib diisi.');
                return false;
            }
            for (const file of this.form.file_uploads) {
                // Only validate required files (is_required === 1) and exclude HPS (handled separately)
                if (file.is_required === 1 && file.new_file.length === 0 && file.file_dokumen_type.kode !== 'hps') {
                    alert(`File ${file.file_dokumen_type.nama} wajib diunggah.`);
                    return false;
                }
                for (const newFile of file.new_file) {
                    if (file.kode_file === 'kerangka_acuan_kerja' && newFile.type !== 'application/pdf') {
                        alert('Hanya file PDF yang diperbolehkan untuk Kerangka Acuan Kerja.');
                        return false;
                    }             
                    if (file.kode_file === 'bq_spesifikasi' && !['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(newFile.type)) {
                        alert('Hanya file Excel yang diperbolehkan untuk BQ Spesifikasi.');
                        return false;
                    }
                    if (file.kode_file === 'draft_kontrak' && newFile.type !== 'application/pdf') {
                        alert('Hanya file PDF yang diperbolehkan untuk Draft Kontrak.');
                        return false;
                    }
                    /* if (file.kode_file === 'dokumen_lain' && !['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(newFile.type)) {
                        alert('Only Excel files are allowed for Dokumen Lain.');
                        return false;
                    } */
                }
            }
            
            if (this.form.hps.file_hps === null) {
                alert('File HPS wajib diunggah.');
                return false;
            }
            return true;
        },
        submitForm() {
            if (!this.isFormValid || this.isSubmitting) {
                if (!this.isFormValid) {
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Error!', 
                        detail: 'Mohon perbaiki semua kesalahan validasi sebelum mengirim.', 
                        life: 5000 
                    });
                }
                return;
            }
            
            if (this.validateFiles()) {
                this.isSubmitting = true;
                
                // Show loading toast
                this.$toast.add({ 
                    severity: 'info', 
                    summary: 'Memproses...', 
                    detail: 'Sedang mengirim data dokumen pengadaan...', 
                    life: 0,
                    group: 'progress'
                });
                
                Inertia.post(
                    "/dokumen_pengadaan/action_create_penyusunan_dokumen_pengadaan",
                    {
                        form: {
                            ...this.form,
                        },
                        jadwals: this.jadwals,
                    },
                    {
                        preserveState: false,
                        preserveScroll: false,
                        replace: true,
                        onSuccess: (page) => {
                            this.isSubmitting = false;
                            // remove progress toast if still visible
                            if (this.$toast && typeof this.$toast.removeGroup === 'function') {
                                this.$toast.removeGroup('progress');
                            }
                            
                            // Show success toast
                            this.$toast.add({ 
                                severity: 'success', 
                                summary: 'Berhasil!', 
                                detail: 'Dokumen pengadaan berhasil dibuat!', 
                                life: 5000 
                            });
                            
                            // Store success message in session storage for the redirected page
                            sessionStorage.setItem('showSuccessToast', 'true');
                            sessionStorage.setItem('successMessage', 'Dokumen pengadaan berhasil dibuat!');
                            
                            // Manual redirect after delay to allow toast to be seen
                            setTimeout(() => {
                                window.location.href = '/dokumen_pengadaan/dashboard';
                            }, 2000);
                        },
                        onError: (errors) => {
                            this.isSubmitting = false;
                            // remove progress toast if still visible
                            if (this.$toast && typeof this.$toast.removeGroup === 'function') {
                                this.$toast.removeGroup('progress');
                            }
                            
                            // Show error toast with specific error message
                            let errorMessage = 'Terjadi kesalahan saat membuat dokumen pengadaan.';
                            if (errors && Object.keys(errors).length > 0) {
                                const firstError = Object.values(errors)[0];
                                if (Array.isArray(firstError)) {
                                    errorMessage = firstError[0];
                                } else {
                                    errorMessage = firstError;
                                }
                            }
                            
                            this.$toast.add({ 
                                severity: 'error', 
                                summary: 'Error!', 
                                detail: errorMessage, 
                                life: 5000 
                            });
                        },
                        // Ensure loading state resets even on 500 or non-Inertia responses
                        onFinish: () => {
                            this.isSubmitting = false;
                            if (this.$toast && typeof this.$toast.removeGroup === 'function') {
                                this.$toast.removeGroup('progress');
                            }
                        }
                    }
                );
            }
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(value);
        },
    },
});
</script>
